const { get, list } = require('./read')
const { create, update } = require('./write')

module.exports = { get, list, create, update }
